export default "__VITE_PUBLIC_ASSET__c9b4de25__"